import React, { FC } from 'react'
import { Grid, ButtonBase, Typography, makeStyles } from '@material-ui/core'
import classNames from 'classnames'
import { IPlayer } from 'protos'
import Jersey from 'components/Jersey'

import removeIcon from './assets/remove_icon.svg'

type Props = {
  player: IPlayer
  onClick?: () => void
  showRemoveIcon?: boolean
}

const useStyles = makeStyles(theme => {
  return {
    item: {
      flex: 1,
      textAlign: 'center',
    },
    button: {
      width: '100%',
    },
    jersey: {
      marginBottom: theme.spacing(),
    },
    removeIcon: {
      zIndex: 1,
      transform: 'translate(100%, 50%)',
    },
    hideRemoveIcon: {
      visibility: 'hidden',
    },
    notPlaying: {
      color: theme.palette.error.main,
    },
  }
})

const TeamItem: FC<Props> = ({ player, showRemoveIcon, onClick }) => {
  const classes = useStyles()

  return (
    <Grid
      item
      className={classes.item}
    >
      <ButtonBase
        disabled={!onClick}
        className={classes.button}
        onClick={onClick}
      >
        <Grid container direction="column" alignItems="center">
          <img
            src={removeIcon}
            alt=""
            className={classNames(classes.removeIcon, {
              [classes.hideRemoveIcon]: !showRemoveIcon,
            })}
          />

          <Jersey
            className={classes.jersey}
            jersey={player.jersey!}
          />

          <Typography
            variant="caption"
            className={classNames({
              [classes.notPlaying]: player.notPlaying,
            })}
          >
            {player.name}
          </Typography>
        </Grid>
      </ButtonBase>
    </Grid>
  )
}

export default TeamItem
try {
    // @ts-ignore
    TeamItem.displayName = "TeamItem";
    // @ts-ignore
    TeamItem.__docgenInfo = { "description": "", "displayName": "TeamItem", "props": { "player": { "defaultValue": null, "description": "", "name": "player", "required": true, "type": { "name": "any" } }, "onClick": { "defaultValue": null, "description": "", "name": "onClick", "required": false, "type": { "name": "() => void" } }, "showRemoveIcon": { "defaultValue": null, "description": "", "name": "showRemoveIcon", "required": false, "type": { "name": "boolean" } } } };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/components/Team/TeamItem.tsx#TeamItem"] = { docgenInfo: TeamItem.__docgenInfo, name: "TeamItem", path: "src/components/Team/TeamItem.tsx#TeamItem" };
}
catch (__react_docgen_typescript_loader_error) { }